// @flow

// current node process
export const IS_DEVEL = process.env.NODE_ENV !== 'production';

// routes
export const ROOT_ROUTE = '/';
export const COMPARISON_ROUTE = `${ROOT_ROUTE}comparison`;
export const TOP_ROUTE = `${ROOT_ROUTE}top`;
